module.exports = __webpack_public_path__ + "img/pic1.3fd7e5d1.png";